export const VALUE_DELIMITER = '" or "'
